import React, { useState } from 'react';
import { MetaRow } from 'containers/Manage-Questionnaire/styled-components';
import { Intent, Button, InputGroup } from '@blueprintjs/core';
import colors from 'utils/colors';

const CategoryEditor = ({ update, fetch, content, toggleEdit, id, name }) => {
  const [value, setValue] = useState(name);
  const [submitting, toggleSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [isError, toggleError] = useState(false);

  const reset = () => {
    toggleEdit(false);
    setValue(name);
  };

  const clearError = () => {
    setError('');
    toggleError(false);
  };

  const handleValueChange = e => {
    const { value } = e.target;
    if (value.length >= 2) {
      clearError();
    }
    setValue(value);
  };

  const handleSubmit = () => {
    if (value.length >= 2) {
      clearError();
      toggleSubmitting(true);
      update(id, value)
        .then(() => {
          toggleSubmitting(false);
          reset();
          fetch();
        })
        .catch(err => {
          toggleError(true);
          setError(err.response.data.message);
          toggleSubmitting(false);
        });
    } else {
      toggleError(true);
      setError(`${content} must be at least 2 characters.`);
    }
  };
  return (
    <MetaRow>
      <InputGroup
        value={value}
        onChange={handleValueChange}
        intent={isError ? Intent.DANGER : Intent.NONE}
        large
        style={{ minWidth: 300 }}
      />
      <div>
        <Button onClick={reset} minimal text="cancel" />
        <Button
          intent={Intent.PRIMARY}
          text="SAVE"
          disabled={submitting}
          onClick={handleSubmit}
          loading={submitting}
        />
      </div>
      <div style={{ color: colors.red, marginLeft: 10 }}>{error}</div>
    </MetaRow>
  );
};

export default CategoryEditor;
